import { Modal } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../../components/Button";
import { LONG_DATE_TIME_FORMAT } from "../../../../../../../utils/dateFormatter";
import {
  ButtonContainer,
  CancelButton,
  confirmModalCss,
  ContentContainer,
} from "./ArchiveAnswerModal.styles";

interface IArchiveSpirometryConfirmationModalProps {
  time?: string;
  isLoading: boolean;
  handleConfirmModalClose: (confirm: boolean) => Promise<void>;
}

export function ArchiveAnswerModal({
  handleConfirmModalClose,
  isLoading,
  time,
}: IArchiveSpirometryConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("patientPage_proms_archiveAnswer_title")}
      open
      zIndex={3001}
      footer={null}
      width={610}
      height={400}
      className={confirmModalCss()}
      centered
      destroyOnClose
      closeIcon={false}
    >
      <ContentContainer>
        <p
          style={{
            padding: "12px 0 0 0",
            fontWeight: "400",
            color: "#939393",
            marginLeft: "5px",
          }}
        >
          {t("patientPage_proms_archiveAnswer_body", {
            date: dayjs(time).format(LONG_DATE_TIME_FORMAT),
          })}
        </p>
        <ButtonContainer>
          <Button
            label={t("patientPage_proms_archiveAnswer_archive")}
            type="button"
            onClick={() => handleConfirmModalClose(true)}
            isLoading={isLoading}
          />

          <CancelButton isModal onClick={() => handleConfirmModalClose(false)}>
            Cancel
          </CancelButton>
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
}
